import React, { useCallback } from "react";
import FloatingNumber from "../../../../components/input/FloatingNumber";
import { formatCurrency } from "../../../../utils/format";
import ManualField from "./ManualField";
import useManualFields from "../hooks/useManualFields";

export default function EditableClosingCostsSection({
  control,
  FloatingInput,
  getValues,
  setValue,
  cleanNumber,  
  salesPriceFormattedTick,
  handleSellerCalculation,
  CustomSelect,
  closingCostsSection2Array,
  totalClosingMeta,
}) {



  const getVal = useCallback(
    (path, fallback = "") => {
      try {
        if (typeof getValues === "function") {
          const v = getValues(path);
          return v === undefined ? fallback : v;
        }
      } catch (e) {
        return fallback;
      }
      return fallback;
    },
    [getValues]
  );

  // Parsed section 2
  const parsedSection2 = closingCostsSection2Array?.fields?.length
    ? closingCostsSection2Array.fields
    : getVal("closingCostMeta", getVal("parsedSection2", [])) || [];
  const costRows = useManualFields(parsedSection2);

  const rowForFieldItem = useCallback(
    (item, idx) => {
      if (costRows[idx]) return costRows[idx];
      const itemKey = String(item?.key || item?.camelKey || "").trim();
      if (itemKey) {
        const matched = costRows.find(
          (r) =>
            r?._meta?.originalKey === itemKey ||
            r?._meta?.raw?.camelKey === item?.camelKey
        );
        if (matched) return matched;
      }
      return {
        left: {
          label: item?.label ?? "",
          placeholder: item?.label ?? "",
        },
        mid: {
          placeholder: item?.type ?? "",
          options: ["% Loan", "% Sale Price", "Flat Fee"],
        },
        right: {
          placeholder: item?.value != null ? String(item.value) : "",
        },
      };
    },
    [costRows]
  );

  return (
    <>     

      {/* Closing Costs Table */}
      <div className="table-calc-frm">
        <div className="table-calc-frm-inner">
          <div className="calc-frm-field m-top-24">
            <div className="calc-frm-fld form-group clmn-a-width">
              <span className="heading-c">Cost</span>
            </div>
            <div className="calc-frm-fld form-group clmn-b-width">
              <span className="heading-c">Type</span>
            </div>
            <div className="calc-frm-fld form-group clmn-c-width">
              <span className="heading-c">Rate</span>
            </div>
            <div className="calc-frm-fld form-group fld-txt-right clmn-d-width">
              <span className="heading-c">Total</span>
            </div>
          </div>

          {closingCostsSection2Array?.fields?.length
            ? closingCostsSection2Array.fields.map((item, idx) => (
                <ManualField
                  key={item.id || `${item.camelKey}-${idx}`}
                  row={rowForFieldItem(item, idx)}
                  index={idx}
                  fieldItem={item}
                  control={control}
                  FloatingInput={FloatingInput}
                  FloatingNumber={FloatingNumber}
                  CustomSelect={CustomSelect}
                  cleanNumber={cleanNumber}
                  getValues={getValues}
                  setValue={setValue}
                  salesPriceFormattedTick={salesPriceFormattedTick}
                  handleSellerCalculation={handleSellerCalculation}
                />
              ))
            : costRows.map((r) => (
                <ManualField
                  key={r.left.name}
                  row={r}
                  control={control}
                  FloatingInput={FloatingInput}
                  FloatingNumber={FloatingNumber}
                  CustomSelect={CustomSelect}
                  cleanNumber={cleanNumber}
                  getValues={getValues}
                  setValue={setValue}
                  salesPriceFormattedTick={salesPriceFormattedTick}
                  handleSellerCalculation={handleSellerCalculation}
                />
              ))}
        </div>
      </div>

      <div className="calc-frm-field">
        <div className="total-amunt-fld">
          <div className="amount-txt heading-c">Total Closing Costs</div>
          <div className="amount-number heading-c">
            ${formatCurrency(totalClosingMeta.sellerCostsTotal) || "0.00"}
          </div>
        </div>
      </div>
    </>
  );
}
